import getUserName from "utils/getUserName";

export const parseLawyerData = (lawyer, orgName, orgLocations) => {
  const location = lawyer?.user?.professional?.locations?.[0] || orgLocations?.[0] || {};

  return {
    name: getUserName(lawyer.user) || lawyer?.user?.professional?.profile?.email,
    orgName,
    location: {
      phone: location?.phone || "",
      postal: location?.postal || "",
      country: location?.country || "Canada",
      residence: location?.residence || null,
      street1: location?.street1 || "",
      street2: location?.street2 || "",
      city: location?.city || "",
      email: lawyer?.user?.professional?.profile?.email || "",
      fax: location?.fax || lawyer?.user?.professional?.profile?.fax || "",
    },
  };
};
